/**
 * TopBar — sticky header with brand, range label, preset buttons, and date-range picker.
 *
 * Props:
 *   preset / setPreset
 *   customStart / setCustomStart
 *   customEnd   / setCustomEnd
 *   loading
 *   showDateEdit / setShowDateEdit
 *   rangeLabel
 *   fetchData
 */
import React from 'react';
import { QUICK_PRESETS, PRESETS, computeRange, toLocalInput } from '../squareDashboardUtils';

export default function TopBar({
  preset, setPreset,
  customStart, setCustomStart,
  customEnd, setCustomEnd,
  loading,
  showDateEdit, setShowDateEdit,
  rangeLabel,
  fetchData,
}) {
  function handleQuickClick(p) {
    setPreset(p.key);
    const r = computeRange(p.key);
    setCustomStart(toLocalInput(r.start));
    setCustomEnd(toLocalInput(r.end));
  }

  function handleRangeClick(p) {
    setPreset(p.key);
    if (p.key !== 'custom') {
      const r = computeRange(p.key);
      setCustomStart(toLocalInput(r.start));
      setCustomEnd(toLocalInput(r.end));
    }
  }

  return (
    <header className="sq__topbar">
      <div className="sq__topbar-inner">
        {/* Brand */}
        <div className="sq__brand">
          <div className="sq__brand-icon">&#x1F4B0;</div>
          <div>
            <div className="sq__brand-title">Square Sales</div>
            <button
              className="sq__brand-range"
              onClick={() => setShowDateEdit(v => !v)}
              title="Click to change dates"
            >
              {rangeLabel} {showDateEdit ? '\u25B4' : '\u25BE'}
            </button>
          </div>
        </div>

        {/* Preset rows + refresh */}
        <div className="sq__topbar-right">
          <div className="sq__preset-rows">
            <div className="sq__preset-row sq__preset-row--quick">
              <span className="sq__preset-group-label">Quick:</span>
              {QUICK_PRESETS.map(p => (
                <button
                  key={p.key}
                  className={`sq__preset sq__preset--quick${preset === p.key ? ' active' : ''}`}
                  onClick={() => handleQuickClick(p)}
                >
                  {p.label}
                </button>
              ))}
            </div>
            <div className="sq__preset-row">
              <span className="sq__preset-group-label">Range:</span>
              {PRESETS.map(p => (
                <button
                  key={p.key}
                  className={`sq__preset${preset === p.key ? ' active' : ''}`}
                  onClick={() => handleRangeClick(p)}
                >
                  {p.label}
                </button>
              ))}
            </div>
          </div>

          <button className="sq__refresh" onClick={fetchData} disabled={loading} title="Refresh">
            {loading ? <span className="sq__spin" /> : '\u21BB'}
          </button>
        </div>
      </div>

      {/* Custom date-range bar */}
      {(showDateEdit || preset === 'custom') && (
        <div className="sq__custom-bar">
          <span className="sq__custom-bar-label">Date range:</span>
          <label>
            From
            <input
              type="datetime-local"
              value={customStart}
              onChange={e => { setCustomStart(e.target.value); setPreset('custom'); }}
            />
          </label>
          <label>
            To
            <input
              type="datetime-local"
              value={customEnd}
              onChange={e => { setCustomEnd(e.target.value); setPreset('custom'); }}
            />
          </label>
          <button className="sq__apply-btn" onClick={() => { fetchData(); setShowDateEdit(false); }}>Apply</button>
          <button className="sq__cancel-btn" onClick={() => setShowDateEdit(false)}>✕</button>
        </div>
      )}
    </header>
  );
}
